<template>
  <div>
    <apexchart
        v-if="chartData"
        class="apex-charts"
        height="40"
        type="area"
        dir="ltr"
        :series="series"
        :options="trendChartOptions"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: "KeywordTrendChart",
  props: {
    chartData: {
      default: null
    }
  },
  data() {
    return {
      loading: true,
      trendChartOptions: {
        chart: {
          type: 'area',
          height: 40,
          sparkline: {
            enabled: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ['#50a5f1'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [25, 100, 100, 100]
          }
        },
        tooltip: {
          fixed: {
            enabled: false
          },
          marker: {
            show: false
          }
        }
      },
    }
  },
  computed: {
    series() {
      const vm = this
      const data = vm.chartData.reverse().map((item) => {
        return {
          x: `${item.month}/${item.year}`,
          y: item.search_volume,
        }
      })
      return [
        {
          name: 'Volume',
          data
        }
      ]
    }
  },
}
</script>

<style scoped>

</style>